import React from 'react';
import { useTranslation } from 'react-i18next';
import SourcesSearch from '../../../../pages/Articles/GenerateDraft/Sources/SourcesSearch';
import { MAX_SOURCES } from '../../lib/sources';

/**
 * Step 3 (sources): multi-select of article sources.
 * Extracted verbatim from pages/Articles/CreateArticle.js.
 */
export default function SourcesStep({
  articleContext,
  handleToggleArticleSource,
  keywordSearchContext,
  language,
  sourceSearchContext,
  sources,
  triggerSourcesSearch,
}) {
  const { t } = useTranslation();

  return (
    <section id="article-sources" className="mb-8 pt-0">
      <h2 className="text-xl font-medium mb-1">
        {t('articles.create.articleSources.selectionTitle', { selected: sources.length, max: MAX_SOURCES })}
      </h2>
      <p className="text-base text-gray-500 mb-4">
        {t('articles.create.articleSources.description')}
      </p>
      <SourcesSearch
        articleContext={sourceSearchContext || keywordSearchContext || articleContext}
        sources={sources}
        onSourceSelect={handleToggleArticleSource}
        triggerSearch={triggerSourcesSearch}
        language={language}
        multiSelect
        maxSources={MAX_SOURCES}
        layout="table"
        hideHeader
        hideCloseButton
        key="article-sources-search-component"
        onSearchComplete={() => { }}
        onClose={() => {}}
      />
    </section>
  );
}
